import { NodeModel, PortModelAlignment } from '@projectstorm/react-diagrams';
import { makeObservable, observable, reaction } from 'mobx';
import { find } from 'lodash';

import rootStore from '@/store/RootStore';
import { Device } from '@/store/Station/constants';

import { FourPortPipeModel } from '../ports/FourPortPipeModel';

interface Point {
  x: number;
  y: number;
}

export class Node extends NodeModel {
  @observable alerts;
  rootStore: typeof rootStore;
  device: Device;
  onDevices: Device[];

  constructor({ device, type, options = {} }) {
    super({
      ...options,
      type,
    });
    makeObservable(this);

    this.rootStore = rootStore;
    this.device = device ?? {};
    this.onDevices = this.getOnDevices();
    this.addPort(new FourPortPipeModel(PortModelAlignment.TOP));
    this.addPort(new FourPortPipeModel(PortModelAlignment.LEFT));
    this.addPort(new FourPortPipeModel(PortModelAlignment.BOTTOM));
    this.addPort(new FourPortPipeModel(PortModelAlignment.RIGHT));
    this.alerts = this.getAlerts();

    reaction(
      () => this.rootStore.alertStore.alerts.map(o => [o.affectedDevicesWithAttributes, o.status]),
      () => {
        this.alerts = this.getAlerts();
      },
    );
  }

  // override setPosition to floor-round x,y and avoid sub-pixel glitch in AlertsWidget
  // (number of alerts is not vertically centered)
  setPosition(x: number | Point, y?: number) {
    return super.setPosition(Math.floor(typeof x === 'number' ? x : x?.x), Math.floor(y));
  }

  getAlerts() {
    return this.rootStore.alertStore.filterAlertsByDeviceId(this.device.deviceId);
  }

  getOnDevices() {
    const { onDevices } = this.device;

    if (!onDevices) return [];

    const finalOnDevices = onDevices.map(deviceId => {
      return find(this.rootStore.stationStore.currentStation.devices, { deviceId });
    });

    return finalOnDevices;
  }

  getEntity() {
    return this.device;
  }
}
